module.exports = __webpack_public_path__ + "img/ex3.1ccb3695.png";